type RedirectWindow = Pick<Window, 'location' | 'top'>;

/**
 * Sends a customer to a form's redirect page after submitting. An embedded
 * form navigates the top window; a cross-origin parent or a sandboxed frame
 * may refuse, so this reports whether navigation was started. On `false` the
 * caller keeps its success message and Continue link on screen.
 */
export function redirectAfterSubmit(
  url: string,
  embedded: boolean,
  win: RedirectWindow = window,
): boolean {
  try {
    if (!embedded) {
      win.location.assign(url);
      return true;
    }
    if (!win.top) return false;
    win.top.location.href = url;
    return true;
  } catch {
    return false;
  }
}
